var axios = require('axios')
var findIndex = require('lodash/findIndex')
var stringify = require('json-stable-stringify')
require('sorttable/sorttable.js')

document.title = 'Expense Reports - Finch'

Vue.component('multiselect', require('vue-multiselect').default)

var app = new Vue({
  el: '#app',
  data: {
    loading: true,
    errorLoading: false,
    role: 'None',
    uncategorizedExpenseAccountsId: 0,
    purchases: [],
    submissions: [],
    attachments: [],
    expenseAccounts: [],
    allowedExpenseAccounts: [],
    useClasses: false,
    useDepartments: false,
    classes: [],
    departments: [],
    toSubmitForReview: [],
    reportId: undefined,
    openedReport: false,
    sendToQbo: false,
    submittingReport: false,
    submittingAllSubmissions: false,
    error: false,
    expenseIsSplittable: false,
    totalOfAllLineItems: 0,
    lineItemIdIterator: 1,
    modalErrorMessage: null,
    showDiff: false,
    diffQuickbooks: '',
    diffLocal: ''
  },
  watch: {
    openedReport: {
      handler (value) {
        for (let i = 0; i < value.Line.length; i++) {
          const line = value.Line[i];
          if (line.selectedExpenseAccount) {
            line.AccountBasedExpenseLineDetail.AccountRef.name = line.selectedExpenseAccount.Name
            line.AccountBasedExpenseLineDetail.AccountRef.value = line.selectedExpenseAccount.Id
          }
        }
      },
      deep: true
    },
    deep: true
  },
  filters: {
    currency (value) {
      return '$' + value.toFixed(2)
    }
  },
  created () {
    axios.get('/api/expense-reports')
         .then((response) => {
           this.loading = false
           var purchases = response.data.purchases
           for (let report of purchases) {
             for (let submission of response.data.ownSubmissions) {
               if (report.content.Id === submission.content.Id) {
                 report.content = submission.content
                 report.attachments = submission.attachments
               }
             }
             if (!report.content.Line || !report.content.Line[0] || !report.content.Line[0].AccountBasedExpenseLineDetail) {
               continue
             }
             if (!report.content.Line[0].AccountBasedExpenseLineDetail.ClassRef) {
               report.content.Line[0].AccountBasedExpenseLineDetail.ClassRef = {}
             }
             if (!report.content.DepartmentRef) {
               report.content.DepartmentRef = {}
             }
           }
           this.role = response.data.role
           this.expenseReportsNeedsReviewer = response.data.expenseReportsNeedsReviewer
           this.uncategorizedExpenseAccountsId = response.data.uncategorizedExpenseAccountsId
           this.purchases = purchases
           this.submissions = response.data.otherSubmissions
           this.useClasses = response.data.preferences.ClassTrackingPerTxnLine
           this.useDepartments = response.data.preferences.TrackDepartments
           this.classes = response.data.classes
           this.departments = response.data.departments
           this.expenseAccounts = response.data.expenseAccounts

           Vue.nextTick(() => {
             document.getElementById('uncategorized-date-header').click()
             document.getElementById('submitted-date-header').click()
           })
         })
         .catch((err) => {
           this.loading = false
           this.errorLoading = true
           console.log(err)
         })
  },
  methods: {

    accountWithFullyQualifiedNameAndNumber({FullyQualifiedName, AcctNum}) {
      if (AcctNum && FullyQualifiedName) {
        return `${FullyQualifiedName} [${AcctNum}]`
      } else if (FullyQualifiedName) {
        return FullyQualifiedName
      } else {
        return 'Select an account'
      }
    },

    reportDate (report) {
      return report.content.TxnDate.replace(/([0-9]*)-([0-9]*)-([0-9]*)/, '$2/$3/$1')
    },

    openReport (report, sendToQbo) {

      this.error = false
      this.sendToQbo = sendToQbo
      this.reportId = report.id
      this.openedReport = JSON.parse(JSON.stringify(report.content))
      this.attachments = report.attachments || []
      for ( let line of this.openedReport.Line ) {
        for (let account of this.expenseAccounts) {
          if (line.AccountBasedExpenseLineDetail.AccountRef.value === account.Id) {
            line.selectedExpenseAccount = account
          } else if (!line.AccountBasedExpenseLineDetail.AccountRef.value) {
            line.selectedExpenseAccount = {}
            this.modalErrorMessage = 'We encountered an error retrieving the selected expense account. Please choose the account that this expense should be assigned to.'
          }
        }
      }

      if (window.userExpenseAccounts != null &&  window.userExpenseAccounts.length > 0) {
        this.allowedExpenseAccounts = [];
        var accounts = window.userExpenseAccounts

        for (var i = 0; i < accounts.length; i++) {
          var account = app.expenseAccounts.filter(item => item.Id == Number(accounts[i]))
          if (account[0]) {
            app.allowedExpenseAccounts.push(account[0])
          } else {
            continue
          }
        }
      }

      // Insert any additional accounts that the user should
      // have access to temporarily
      for (let lineItem of this.openedReport.Line) {
        if (lineItem.selectedExpenseAccount) {
          var lineItemAccount = lineItem.selectedExpenseAccount.Id
          for (let expenseAccount of app.expenseAccounts) {
            if (
              lineItemAccount === expenseAccount.Id &&
              app.allowedExpenseAccounts.filter(item => item.Id == Number(lineItemAccount)).length === 0
              ) {
              var acct = app.expenseAccounts.filter(item => item.Id == Number(lineItemAccount))
              app.allowedExpenseAccounts.push(acct[0])
            }
          }
        }
      }

      Vue.nextTick(() => {
        $('#expense-report-modal').modal('show')
        // Add the amount of each expense line item together
        this.lineItemIdIterator = this.openedReport.Line.length
        this.updateEnteredAmount()
      })
    },

    updateLines(lineItem) {
      // Avoid overwriting index 0 when adding new lines
      if (lineItem.Amount) {
        var index = findIndex(this.openedReport.Line, lineItem)
        Vue.set(this.openedReport.Line, index, lineItem)
      }
    },

    viewAttachment (file) {
      document.getElementById('expense-report-attachment-img').src = file
    },

    filesChange (e) {
      var toLoad = e.target.files || e.dataTransfer.files
      var i = 0
      var loadFile = () => {
        var file = toLoad[i++]
        if (!file) {
          e.target.value = ''
          return
        }

        var reader = new FileReader()
        reader.onload = (e) => {
          this.attachments.push(e.target.result)
          loadFile()
        }
        reader.readAsDataURL(file)
      }
      loadFile()
    },

    changeClass () {
      for (let klass of this.classes) {
        if (klass.Id === this.openedReport.Line[0].AccountBasedExpenseLineDetail.ClassRef.value) {
          this.openedReport.Line[0].AccountBasedExpenseLineDetail.AccountRef.name = klass.FullyQualifiedName
        }
      }
    },

    removeAttachment (i) {
      this.attachments.splice(i, 1)
    },

    // Allow the user to split the transaction
    addExpenseLineItem () {

      // clone report.content.Line[0]
      var newSplitLine = JSON.parse(JSON.stringify(this.openedReport.Line[0]))

      // Increment the ID,
      newSplitLine.Id = JSON.stringify(this.lineItemIdIterator += 1)

      // Set the amount to $0
      newSplitLine.Amount = 0

      // Set the Description to an empty string
      newSplitLine.Description = ''

      // Insert the new object into the array
      this.openedReport.Line.push(newSplitLine);

      // Update the total to include all line items
      this.updateEnteredAmount()

    },

    updateEnteredAmount () {

      this.totalOfAllLineItems = 0

      for (let i = 0; i < this.openedReport.Line.length; i++) {
        const lineItem = this.openedReport.Line[i];
        this.totalOfAllLineItems += parseFloat(lineItem.Amount)
      }

      this.totalOfAllLineItems = Number(this.totalOfAllLineItems.toFixed(2))
    },

    removeExpenseLineItem (index) {
      this.totalOfAllLineItems = this.totalOfAllLineItems - this.openedReport.Line[index].Amount
      this.openedReport.Line.splice(index, 1)
    },

    removeEmptyLineItems () {
      // Remove empty line items from the split
      for (let i = 0; i < this.openedReport.Line.length; i++) {
        const lineItem = this.openedReport.Line[i];
        if (lineItem.Amount <= 0 || lineItem.Amount == null) {
          this.openedReport.Line.splice(i, 1)
        }
      }
    },

    submitAllSubmissions () {
      $('#expense-report-processing-modal').modal('show')
      this.submittingAllSubmissions = true
      this.error = false

      var submitSubmission = () => {
        if (this.submissions.length === 0) {
          $('#expense-report-processing-modal').modal('hide')
          this.submittingAllSubmissions = false
          return
        }

        this.openedReport = this.submissions[0].content

        this.submitReport((err) => {
          if (err) {
            this.submittingAllSubmissions = false
            this.error = err
          } else {
            submitSubmission()
          }
        })
      }
      submitSubmission()
    },

    submitReport (callback) {
      this.removeEmptyLineItems()

      this.error = false
      this.submittingReport = true

      for (let line of this.openedReport.Line) {
        delete line.selectedExpenseAccount
      }

      for (let purchase of this.purchases) {
        if (purchase.content.Id === this.openedReport.Id) {
          purchase.content = this.openedReport
          purchase.attachments = this.attachments
        }
      }
      axios.post('/api/expense-reports', {id: this.reportId, report: this.openedReport, attachments: this.attachments})
           .then((response) => {
        this.submittingReport = false

        if (response.status >= 400) {
          if (callback) {
            if (response.data.message || response.data.error) {
              callback(response.data.message || response.data.error)
            } else {
              callback('Error from server when submitting expense report')
            }
          }
          return
        }

        $('#expense-report-modal').modal('hide')

        if (!response.data.editable) {
          for (var i = 0; i < this.submissions.length; i++) {
            if (this.submissions[i].content.Id === this.openedReport.Id) {
              this.submissions.splice(i, 1)
            }
          }
          if (callback) callback()
          return
        }

        var found = false
        for (var i = 0; i < this.toSubmitForReview.length; i++) {
          if (this.toSubmitForReview[i].Id === this.openedReport.Id) {
            found = true
            break
          }
        }
        if (!found) {
          this.toSubmitForReview.push(this.openedReport)
        }
        if (callback) callback()
      }).catch((err) => {
        this.submittingReport = false

        if (err.response && (err.response.data.message || err.response.data.error)) {
          this.error = err.response.data.message || err.response.data.error
          if (callback) {
            callback(err.response.data.message || err.response.data.error)
          }
        } else {
          this.error = 'There was an error submitting this expense report'
          callback('Error from server when submitting expense report')
        }
      })
    },

    submitForReview () {
      this.removeEmptyLineItems()
      axios.post('/api/expense-reports/submit-for-review', {reportIds: this.toSubmitForReview.map((report) => report.Id)})
           .then((response) => {
             this.toSubmitForReview = []
           })
    },

    createDiff () {
      this.diffLocal = this.openedReport
      axios.get('/api/expense-reports/purchases/' + this.openedReport.Id).then((response) => {
        this.diffQuickbooks = response.data.purchase
      })
      this.showDiff = true
    },

    // createDiff () {
    //   this.diffLocal = stringify(this.openedReport, { space: '  ' })
    //   axios.get('/api/expense-reports/purchases/' + this.openedReport.Id).then((response) => {
    //     this.diffQuickbooks = stringify(response.data.purchase, { space: '  ' })
    //   })
    //   this.showDiff = true
    // },

    removeReport () {
      axios.post('/api/expense-reports/remove/' + this.reportId).then((response) => {
        if (response.data.ok) {
          $('#expense-report-modal').modal('hide')
          for (var i = 0; i < this.submissions.length; i++) {
            if (this.submissions[i].content.Id === this.openedReport.Id) {
              this.submissions.splice(i, 1)
            }
          }
        } else {
          this.modalErrorMessage = 'We encountered an error removing this expense report.'
        }
      })
    }

  }
})
